import { render, staticRenderFns } from "./UnreadGroup.vue?vue&type=template&id=4d043db7&"
import script from "./UnreadGroup.vue?vue&type=script&lang=ts&"
export * from "./UnreadGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports